import styled from 'styled-components';
import Input from './Input';

export default styled(Input)`
  width: ${props => (props.width ? props.width : 'auto')};
  height: ${props => (props.height ? props.height : '1rem')};
  -webkit-appearance: searchfield;
  padding-right: 1.2rem;
  background-image: url('images/magnifyingGlass.png');
  background-position: right center;
  background-repeat: no-repeat;
  border-color: ${props => (props.borderColor ? props.borderColor : '#A9A9A9')};

  &[type="search"]::-webkit-search-cancel-button {
    -webkit-appearance:searchfield-cancel-button;
  }
`;



// WEBPACK FOOTER //
// ./app/styled-components/SearchBox.js